import { ReactNode, useEffect, useState } from "react";
import { BcModalActive } from "../../styled/global.styled";
import BcIcon from "../Bc-Icon/Bc-icon";

interface Props {
  openModal: boolean;
  children: ReactNode;
  type: "default" | "success" | "error" | "info" | "warning";
  widthOption: "small" | "medium" | "large";
  title: string;
  subTitle?: string;
  onClose: () => void;
}

const iconModal = (label: string): string => {
  switch (label) {
    case "success":
      return "ok";
    case "error":
      return "error";
    case "info":
      return "idea";
    case "warning":
      return "hand";
    default:
      return "default";
  }
};

const BcModal = ({
  openModal,
  type,
  widthOption,
  children,
  title,
  subTitle,
  onClose
}: Props) => {

  const [open, setOpen] = useState<boolean>(openModal);

  const handleClick = () => {
    setOpen(openModal);
    onClose();
  };

  useEffect(() => {
    setOpen(openModal);
  }, [openModal]);

  return (
    <>
      {open && (
        <BcModalActive widthOption={widthOption} iconOption={type}>
          <label className="bc-modal-close" htmlFor=""></label>
          <section className="bc-modal-container">
            <div className="bc-modal-close-button-container">
              <div>
                <button
                  type="button"
                  title="button"
                  className="bc-direction-row bc-icon bc-modal-close-button"
                  onClick={handleClick}
                >
                  <BcIcon iconName="error" />
                </button>
              </div>
            </div>
            {type !== "default" && (
              <section className="bc-modal-icon-container">
                <div>
                  <BcIcon iconName={iconModal(type)} />
                </div>
              </section>
            )}
            <section className="bc-modal-title bc-direction-row">
              <h4 className="modal-title-label">{title}</h4>
            </section>
            {subTitle && (
              <section className="bc-modal-title bc-direction-row">
                <p>{subTitle}</p>
              </section>
            )}
            <>{children}</>
            <div className="bc-modal-footer"></div>
          </section>
        </BcModalActive>
      )}
    </>
  );
};

export default BcModal;

BcModal.defaultProps = {
  type: "default",
  widthOption: "small",
  title: 'Modal title example'
};
